export const TIME_INTERVAL_IN_MINUTES = 60;
export const TIME_INTERVAL_IN_SECONDS = 1800;
export const HOUR_IN_SECONDS = 3600;
export const MINUTE_IN_MICROSECONDS = 1000 * 1000 * 60;
export const CODE_PROFILE_THRESHOLD_IN_PERCENTAGES = 20;

export const AO_MISSING_EVENT_ERROR =
  "AppOptics Trace Processing: Missing Event(s)";

export const extentTypeEnum = {
  LOCAL_CODE: "local",
  REMOTE_CALL: "outboundcall",
  DATABASE_CALL: "query",
  CACHE_CALL: "cache",
};

export const outcomeEnum = {
  PROFILE_SUMMARY: "PROFILE SUMMARY",
  GENERAL_SUMMARY: "GENERAL SUMMARY",
  REMOTE_CALL_SUMMARY: "REMOTE CALL SUMMARY",
  DATABASE_SUMMARY: "DATABASE CALL SUMMARY",
  CACHE_SUMMARY: "CACHE CALL SUMMARY",
  REMOTE_CALL_SPAN_SUMMARY: "REMOTE CALL SPAN SUMMARY",
  DATABASE_SPAN_SUMMARY: "DATABASE CALL SPAN SUMMARY",
  CACHE_SPAN_SUMMARY: "CACHE CALL SPAN SUMMARY",
};

export const TRACE_BREAKDOWN_THEME = {
  axis: {
    ticks: {
      text: {
        fontSize: 11,
      },
    },
  },
  grid: {
    line: {
      stroke: "#ffffff",
      strokeWidth: 1,
    },
  },
};

export const CALLS_ORDER_BY = {
  sort: "AVERAGE_RESPONSE_TIME",
  direction: "DESC",
};

export const TRACE_SERVICE_RESPONSE_TIME = "trace.service.response_time";
export const TRACE_SERVICE_REQUEST = "trace.service.requests";
export const DISK_UTILIZATION = "system.io.io_time";
export const MEMORY_UTILIZATION = "system.mem.percent.used";
export const CPU_UTILIZATION = "system.cpu.utilization";
export const CLOUDWATCH_CPU_UTILIZATION = "AWS.EC2.CPUUtilization";
export const CLOUDWATCH_DISK_UTILIZATION = "AWS.EC2.DiskReadOps";

export const SERVICE_RELATED_METRICS = [
  TRACE_SERVICE_RESPONSE_TIME,
  TRACE_SERVICE_REQUEST,
];

export const HOST_RELATED_METRICS = [MEMORY_UTILIZATION, CPU_UTILIZATION];

export const CLOUDWATCH_RELATED_METRICS = [
  CLOUDWATCH_CPU_UTILIZATION,
  CLOUDWATCH_DISK_UTILIZATION,
];
